import { type FC } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import LockIcon from "@mui/icons-material/Lock";
import LogoutIcon from "@mui/icons-material/Logout";

export interface AccessDeniedProps {
  onSignOut: () => void;
  loading: boolean;
}

export const AccessDenied: FC<AccessDeniedProps> = ({ onSignOut, loading }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "background.default",
        p: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 400,
          textAlign: "center",
          boxShadow: 3,
        }}
      >
        <CardContent sx={{ pt: 4, pb: 2 }}>
          <Box sx={{ mb: 3 }}>
            <LockIcon
              sx={{
                fontSize: 64,
                color: "error.main",
                mb: 2,
              }}
            />
          </Box>

          <Typography variant="h5" component="h1" gutterBottom>
            Доступ ограничен
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            У вас нет прав доступа к кабинету.
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Для получения доступа обратитесь к администратору системы.
          </Typography>
        </CardContent>

        <CardActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={onSignOut}
            disabled={loading}
            startIcon={<LogoutIcon />}
            size="large"
          >
            {loading ? "Выход..." : "Выйти"}
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};
